import { render, staticRenderFns } from "./transferenciaActividades.vue?vue&type=template&id=bc1efcde&scoped=true"
import script from "./transferenciaActividades.vue?vue&type=script&lang=js"
export * from "./transferenciaActividades.vue?vue&type=script&lang=js"
import style0 from "./transferenciaActividades.vue?vue&type=style&index=0&id=bc1efcde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1efcde",
  null
  
)

export default component.exports